import React from 'react';
import {
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { withLocalePrefix } from 'shared/utils/translation';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import LazyEllipsisMenu from 'talent_matching/components/shared/lazy_ellipsis_menu';
import { useRediscoveryRowActionsModal } from 'talent_matching/contexts/rediscovery_row_actions_modal_context';

const t = withLocalePrefix('talent_matching.rediscovery.table.actions');

type RediscoveryRowActionsProps = {
  applicationId: number;
};

const RediscoveryRowActions = ({
  applicationId,
}: RediscoveryRowActionsProps) => {
  const { application } = useRediscoveryApplication(applicationId);
  const { openTagsFor, openProspectFor, openEmailFor, openAddToJobFor } =
    useRediscoveryRowActionsModal();

  if (!application) {
    return null;
  }

  const handleViewCandidate = () => {
    window.open(application.candidateProfilePath, '_blank');
  };

  return (
    <LazyEllipsisMenu ariaLabel={t('actions')}>
      <MenuList>
        <MenuItem onSelect={handleViewCandidate}>
          {t('view_candidate')}
        </MenuItem>
        <MenuItem onSelect={() => openProspectFor(application)}>
          {t('add_prospect')}
        </MenuItem>
        <MenuItem onSelect={() => openAddToJobFor(application)}>
          {t('add_to_job')}
        </MenuItem>
        <MenuItem onSelect={() => openTagsFor(application)}>
          {t('tag')}
        </MenuItem>
        <MenuItem onSelect={() => openEmailFor(application)}>
          {t('send_email')}
        </MenuItem>
      </MenuList>
    </LazyEllipsisMenu>
  );
};

export default RediscoveryRowActions;
